import axios from 'axios';
import router from '@/router/index.js'
import Vue from 'vue'
import bootbox from 'bootbox';
import VueI18n from 'vue-i18n'
import store from '@/store/index.js'

var permissions = [];

var Auth = {
	install: function (Vue, options) {
		var auth = {
	    	login: login,
	    	loginAs: loginAs,
	    	logout: logout,
			hasPermission: hasPermission,
			getCookieValue: getCookieValue
	    };

		Vue.$auth = auth;
		Vue.prototype.$auth = auth;
	}
}

Vue.use(Auth)

function login(_permissions, user) {
	store.commit('user/login', user);
	permissions = _permissions;
	axios.defaults.headers.common = {'xsrf-token': getCookieValue('xsrf-token')};
}

function logout(redirect) {
	axios
	.post('login/logout/')
	.then(response => {
		permissions = [];
		delete axios.defaults.headers.common["xsrf-token"];
		store.commit('user/logout');
		if(redirect) {
			router.replace({path: '/login', query: {redirect: router.currentRoute.path}});
		} else {
			router.push({path: '/login'});
		}
	 });
}

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

function hasPermission() {
	for (var i=0; i < arguments.length; i++) {
		if($.inArray(arguments[i], permissions) >= 0) {
			return true;
		}
	}

	if($.inArray("selfUser", arguments) >= 0) {
		let id = router.history.pending !== null ? router.history.pending.params.id : router.currentRoute.params.id;
		if(id == store.getters['user/id']) {
			return true;
		}
	}
	return false;
}

function loginAs(userId){
  axios
    .post('login/loginAs', {
      userId: userId
    })
    .then(response => {
    	permissions = response.data.permissions;
		store.commit('user/login', response.data.user)
    	router.push({path: '/'});
    })
}



// WEBPACK FOOTER //
// ./src/javascript/plugins/auth.js